module.exports = __webpack_public_path__ + "static/media/shipping-courier.68a58c62.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/oberg/shipping-courier.jpeg
// module id = 1284
// module chunks = 0